import React, { useState } from "react"
import Dropzone from "react-dropzone"
import { useTranslation } from "react-i18next"
import * as Components from "../components/components"
import { EventBus } from "../eventbus"
import { ButtonStyle } from "../models/ButtonStyle"
import { Rechnung } from "../models/rechnung"
import { RechnungBuilder } from "../models/rechnungsbuilder"
import { handleErrors, uploadAdvices } from "../Utils"
import { useCookies } from "react-cookie"

interface MessageViewProps {
    text: string
    type: "info" | "warning" | "danger" | "success"
}

export default function VorlageUploadView() {
    const [messages, setMessages] = useState<MessageViewProps[]>([])
    const [loading, setLoading] = useState<boolean>(false)
    const { t } = useTranslation()
    const [cookies] = useCookies(["XSRF-TOKEN"])

    const onFileSelected = (files: File[]) => {
        if (files.length === 0) return

        const file = files[0]
        if (!["text/xml", "application/vnd.ms-excel"].includes(file.type)) {
            say(t("general.eventbusNachrichten.dateiUpload.falscherDateityp"), "warning", true)
            return
        }
        setLoading(true)

        const formdata: FormData = new FormData()
        formdata.append("file", file, file.name)

        fetch("/api/v1/tosca", {
            method: "POST",
            credentials: "include",
            headers: { "X-XSRF-TOKEN": cookies["XSRF-TOKEN"] },
            body: formdata,
        })
            .then(handleErrors)
            .then((r) => r.json())
            .then((data) => {
                const model: Rechnung = new RechnungBuilder().fromJSON(data).build()
                EventBus.instance.emit("loadModel", model)
                EventBus.instance.emit("processValidate", null)
                say(t("general.eventbusNachrichten.dateiUpload.erfolgreich"), "success", true)
                setLoading(false)
            })
            .catch((err) => {
                say(t("general.eventbusNachrichten.dateiUpload.fehler"), "danger", true)
                EventBus.instance.emit("collapsible:hide")
                console.log(err)
                setLoading(false)
            })
    }

    const say = (text: string, type: "info" | "warning" | "danger" | "success", clear?: boolean) => {
        clear
            ? setMessages([{ text: text, type: type }])
            : setMessages((current) => [
                  ...current,
                  {
                      text: text,
                      type: type,
                  },
              ])
    }

    return (
        <div className="card w-100 text-center">
            <Dropzone maxFiles={1} onDrop={(acceptedFiles) => onFileSelected(acceptedFiles)}>
                {({ getRootProps, getInputProps, isDragActive }) => (
                    <section>
                        <div {...getRootProps()} className="card-upload py-5" onClick={(e) => e.stopPropagation()}>
                            <input {...getInputProps()} id="template-upload-input" />
                            {messages.map((message: MessageViewProps, index: number) => {
                                return (
                                    <div key={"alert-" + index} className={`alert alert-${message.type}`}>
                                        {message.text}
                                    </div>
                                )
                            })}
                            <h3>{t("general.dateiUpload.ueberschrift")}</h3>
                            <p>
                                <strong>{isDragActive ? t("general.dateiUpload.dateiAblage.aktiv") : t("general.dateiUpload.dateiAblage.inaktiv")}</strong>
                            </p>
                            <p>{t("general.dateiUpload.verzweigung")}</p>
                            <div>
                                <Components.Button
                                    style={ButtonStyle.PRIMARY}
                                    label={t("general.dateiUpload.button.text")}
                                    onClick={() => document.getElementById("template-upload-input")?.click()}
                                    loading={loading}
                                />
                            </div>
                            <small className="mt-2">
                                <strong id="uploadAdvices">
                                    {uploadAdvices.map((advice: string, idx) => (
                                        <div className="mt-2" key={idx}>
                                            {t(advice)}
                                        </div>
                                    ))}
                                </strong>
                            </small>
                        </div>
                    </section>
                )}
            </Dropzone>
        </div>
    )
}
